import { takeLatest, call, put, all } from 'redux-saga/effects';
import { message } from 'antd';
import httpClient from '../../../utils/HttpClient';
import { ORDERS_URL, CART_URL } from '../../../constants/Url';
import { 
  PLACE_ORDER_NOW_REQUEST,
  PLACE_ORDER_CART_REQUEST,
  PLACE_ORDER_SUCCESS,
  PLACE_ORDER_FAILURE,
  FETCH_ORDER_REQUEST,
  FETCH_ORDER_SUCCESS,
  FETCH_ORDER_FAILURE,
  FETCH_ORDERS_LIST_REQUEST,
  FETCH_ORDERS_LIST_SUCCESS,
  FETCH_ORDERS_LIST_FAILURE
} from '../../shop/actionTypes';

function* placeOrderNow(action) {
  try {
    const { orderData, navigate } = action.payload;
    const res = yield call(httpClient.post, `${ORDERS_URL}/now`, orderData);
    
    if (res.data && (res.status === 200 || res.status === 201 || res.data.status === 200)) {
      const order = res.data.data || res.data;
      console.log('Order created successfully:', order);
      
      let payUrl = order?.paymentUrl || order?.payUrl || order?.redirectUrl || res.data?.paymentUrl || res.data?.data?.paymentUrl;

      if (!payUrl && (orderData.method === 'alipay' || orderData.method === 'wechatpay' || orderData.method === 'wechat')) {
        try {
          const payNowRes = yield call(httpClient.post, `${ORDERS_URL}/pay-now`, {
            orderId: order.orderId || order._id || order.id,
            method: orderData.method === 'wechat' ? 'wechatpay' : orderData.method,
            currency: 'CNY'
          });
          payUrl = payNowRes.data?.data?.paymentUrl || payNowRes.data?.paymentUrl || payNowRes.data?.data?.payUrl;
        } catch (payErr) {
          console.error('pay-now failed:', payErr);
        }
      }

      if (payUrl) {
        yield put({ type: PLACE_ORDER_SUCCESS, payload: order });
        window.location.href = payUrl;
        return;
      }

      yield put({ type: PLACE_ORDER_SUCCESS, payload: order });
      message.success('Order placed successfully');
      
      if (navigate) {
        navigate('/order-confirmation', { state: { orderId: order.orderId || order._id || order.id } });
      }
    } else {
      console.error('Order creation failed:', res.data);
      yield put({ type: PLACE_ORDER_FAILURE, payload: res.data?.message || 'Error placing order' });
      message.error(res.data?.message || 'Error placing order');
    }
  } catch (error) {
    console.error('Order saga caught error:', error);
    yield put({ type: PLACE_ORDER_FAILURE, payload: error.message });
    message.error('Error placing order');
  }
}

function* placeOrderCart(action) {
  try {
    const { orderData, navigate } = action.payload;
    const res = yield call(httpClient.post, `${ORDERS_URL}/checkout`, orderData);
    
    if (res.data && (res.status === 200 || res.status === 201 || res.data.status === 200)) {
      const order = res.data.data || res.data;
      console.log('Cart order created successfully:', order);
      
      // Explicitly clear the cart on the backend BEFORE notifying the UI
      if (orderData.cartId) {
        try {
          yield call(httpClient.delete, `${CART_URL}/${orderData.cartId}/clear`);
          console.log('Backend cart cleared successfully');
        } catch (clearErr) {
          console.error('Backend cart clear failed:', clearErr);
        }
      }

      yield put({ type: 'CLEAR_CART' }); // Optimistically clear cart frontend state
      yield put({ type: 'FETCH_CART_REQUEST' }); // Sync cart state from backend
      window.dispatchEvent(new Event('cart-updated')); // Notify Layout to refresh cart count

      let payUrl = order?.paymentUrl || order?.payUrl || order?.redirectUrl || res.data?.paymentUrl || res.data?.data?.paymentUrl;

      if (!payUrl && (orderData.method === 'alipay' || orderData.method === 'wechatpay' || orderData.method === 'wechat')) {
        try {
          const payNowRes = yield call(httpClient.post, `${ORDERS_URL}/pay-now`, {
            orderId: order.orderId || order._id || order.id,
            method: orderData.method === 'wechat' ? 'wechatpay' : orderData.method,
            currency: 'CNY'
          });
          payUrl = payNowRes.data?.data?.paymentUrl || payNowRes.data?.paymentUrl || payNowRes.data?.data?.payUrl;
        } catch (payErr) {
          console.error('pay-now failed:', payErr);
        }
      }

      if (payUrl) {
        yield put({ type: PLACE_ORDER_SUCCESS, payload: order });
        window.location.href = payUrl;
        return;
      }

      yield put({ type: PLACE_ORDER_SUCCESS, payload: order });
      message.success('Order placed successfully');
      
      if (navigate) {
        navigate('/order-confirmation', { state: { orderId: order.orderId || order._id || order.id } });
      }
    } else {
      console.error('Cart order creation failed:', res.data);
      yield put({ type: PLACE_ORDER_FAILURE, payload: res.data?.message || 'Error placing order' });
      message.error(res.data?.message || 'Error placing order');
    }
  } catch (error) {
    console.error('Cart order saga caught error:', error);
    yield put({ type: PLACE_ORDER_FAILURE, payload: error.message });
    message.error('Error placing order');
  }
}

function* fetchOrder(action) {
  try {
    const res = yield call(httpClient.get, `${ORDERS_URL}/${action.payload}`);
    if (res.data && (res.status === 200 || res.data.status === 200)) {
      yield put({ type: FETCH_ORDER_SUCCESS, payload: res.data.data || res.data });
    } else {
      yield put({ type: FETCH_ORDER_FAILURE, payload: res.data?.message || 'Error fetching order' });
    }
  } catch (error) {
    yield put({ type: FETCH_ORDER_FAILURE, payload: error.message });
  }
}

function* fetchOrdersList(action) {
  try {
    const { pageNo = 1, pageSize = 10, keyword = '', status = 'ALL' } = action.payload || {};
    const qs = `?pageNo=${pageNo}&pageSize=${pageSize}&keyword=${encodeURIComponent(keyword)}&status=${status}`;
    const res = yield call(httpClient.get, `${ORDERS_URL}${qs}`);
    
    if (res.data && (res.status === 200 || res.data.status === 200)) {
      yield put({ type: FETCH_ORDERS_LIST_SUCCESS, payload: res.data });
    } else {
      yield put({ type: FETCH_ORDERS_LIST_FAILURE, payload: res.data?.message || 'Error fetching orders' });
    }
  } catch (error) {
    yield put({ type: FETCH_ORDERS_LIST_FAILURE, payload: error.message });
  }
}

export function* orderWatcher() {
  yield all([
    takeLatest(PLACE_ORDER_NOW_REQUEST, placeOrderNow),
    takeLatest(PLACE_ORDER_CART_REQUEST, placeOrderCart),
    takeLatest(FETCH_ORDER_REQUEST, fetchOrder),
    takeLatest(FETCH_ORDERS_LIST_REQUEST, fetchOrdersList)
  ]);
}
